<template>
    
    <!--Gallery One Start-->
    <section class="gallery-one">
            <div class="gallery-one__top">
                <h3 class="gallery-one__top-title">Nuestra Galería</h3>
            </div>
            <div class="gallery-one__bottom">
                <div class="gallery-one__container">
                    <ul class="list-unstyled gallery-one__list">
                        <li class="gallery-one__single wow fadeInUp" data-wow-delay="100ms">
                            <div class="gallery-one__img">
                                <img src="assets/images/homeGallery/maquina-2.jpg" alt="">
                                <a href="assets/images/homeGallery/maquina.jpg" class="img-popup"></a>
                                <div class="gallery-one__content">
                                    <!-- /.img-popup -->
                                    <p class="gallery-one__sub-title">Diseño e instalación de tableros de fuerza y control</p>
                                    <!-- <h5 class="gallery-one__title"><a href="gallery.html">Maquinaria</a></h5> -->
                                </div>
                            </div>
                        </li>
                        <li class="gallery-one__single wow fadeInUp" data-wow-delay="200ms">
                            <div class="gallery-one__img">
                                <img src="assets/images/homeGallery/grua2.jpg" alt="">
                                <a href="assets/images/homeGallery/grua2-2.jpg" class="img-popup"></a>
                                <div class="gallery-one__content">
                                    <!-- /.img-popup -->
                                    <p class="gallery-one__sub-title">Instalación de Bomba de pozo profundo</p>
                                    <!-- <h5 class="gallery-one__title"><a href="gallery.html">Maquinaria</a></h5> -->
                                </div>
                            </div>
                        </li>
                        <li class="gallery-one__single wow fadeInUp" data-wow-delay="300ms">
                            <div class="gallery-one__img">
                                <img src="assets/images/homeGallery/grua3-4.jpg" alt="">
                                <a href="assets/images/homeGallery/grua3-2.jpg" class="img-popup"></a>
                                <div class="gallery-one__content">
                                    <!-- /.img-popup -->
                                    <p class="gallery-one__sub-title">Extracción de bomba de pozo profundo</p>
                                    <!-- <h5 class="gallery-one__title"><a href="gallery.html">Maquinaria</a></h5> -->
                                </div>
                            </div>
                        </li>
                        <li class="gallery-one__single wow fadeInUp" data-wow-delay="400ms">
                            <div class="gallery-one__img">
                                <img src="assets/images/homeGallery/camion-2.jpeg" alt="">
                                <a href="assets/images/homeGallery/camion.jpeg" class="img-popup"></a>
                                <div class="gallery-one__content">
                                    <!-- /.img-popup -->
                                    <p class="gallery-one__sub-title">Movimiento con camión pluma</p>
                                    <!-- <h5 class="gallery-one__title"><a href="gallery.html">Maquinaria</a></h5> -->
                                </div>
                            </div>
                        </li>
                        <li class="gallery-one__single wow fadeInUp" data-wow-delay="500ms">
                            <div class="gallery-one__img">
                                <img src="assets/images/homeGallery/panel-2.jpg" alt="">
                                <a href="assets/images/homeGallery/panel.jpg" class="img-popup"></a>
                                <div class="gallery-one__content">
                                    <!-- /.img-popup -->
                                    <p class="gallery-one__sub-title">Instalación de Sistema generación Fotovoltaica</p>
                                    <!-- <h5 class="gallery-one__title"><a href="gallery.html">Panel Solar</a></h5> -->
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <!--Gallery One End-->
  
  
  </template>
    <style>
        .gallery-one__bottom {
            padding-top: 60px !important;
            padding-bottom: 60px !important;
        }
    </style>
  <script>

export default {
        mounted(){
            this.thmSwiperInit();
        },
        methods:{
            thmSwiperInit() {
                if ($(".img-popup").length) {
                    var groups = {};
                    $(".img-popup").each(function () {
                    var id = parseInt($(this).attr("data-group"), 10);

                    if (!groups[id]) {
                        groups[id] = [];
                    }

                    groups[id].push(this);
                    });

                    $.each(groups, function () {
                    $(this).magnificPopup({
                        type: "image",
                        closeOnContentClick: true,
                        closeBtnInside: false,
                        gallery: {
                        enabled: true
                        }
                    });
                    });
                }
            }
        }
    }

    
  </script>